import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import styles from './UserFound.module.scss'
import { useNavigate } from 'react-router-dom'
import BackButton from '../../components/buttons/BackButton/BackButton'
import { useAuthStatus } from '../../utils'
import { PasswordChangeModal } from '../../components/modal/PasswordChangeModal'
import { FormProvider, useForm } from 'react-hook-form'

/**
 * Props:
 *  - user: 사용자 정보
 */
export default function UserFound({ user, page = 1, setPage }) {
	const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
	const [email, setEmail] = useState('')
	const navigate = useNavigate()
	const methods = useForm()
	const [isPasswordModalOpen, setPasswordModalOpen] = useState(false)

	const onSubmit = async (data) => {
		try {
			console.log('data:', data)
			const newPassword = methods.getValues('password')
			console.log('newPassword:', newPassword)
			console.log('userId:', user?.id)

			await axios.post(`${API_ENDPOINT}/users/reset-password-simple`, {
				userId: user?.id,
				newPassword: newPassword,
			})

			setPasswordModalOpen(false)
			handleSignin()
		} catch (error) {
			console.error('비밀번호 재설정 실패:', error)
			// 에러 처리는 PasswordChangeModal에서 처리하도록 함
			throw error
		}
	}
	useEffect(() => {
		console.log('전달된 user:', user)
		if (user.user_type === 'tourPro') {
			axios
				.get(`${API_ENDPOINT}/users/user/pro/search/${user.name}`)
				.then((res) => {
					console.log('res:', res)
					setEmail(res.data[0].email || '')
				})
				.catch((err) => {
					console.error('Failed to fetch user email:', err)
				})
		} else if (user.user_type === 'tourCaddie') {
			axios
				.get(`${API_ENDPOINT}/users/user/caddie/search/${user.name}`)
				.then((res) => {
					console.log('res:', res)
					setEmail(res.data[0].email || '')
				})
				.catch((err) => {
					console.error('Failed to fetch user email:', err)
				})
		}
	}, [])

	const handleResetPassword = () => {
		// 비밀번호 재설정 페이지로 이동
		navigate('/reset/password')
	}

	const handleSignin = () => {
		navigate('/login')
	}
	const handleOpenPasswordModal = () => {
		setPasswordModalOpen(true)
	}
	const handleClosePasswordModal = () => {
		setPasswordModalOpen(false)
	}

	return (
		<FormProvider {...methods}>
			<div className={styles.foundContainer}>
				<BackButton onBack={() => setPage(0)} />
				<form className={styles.mainForm}>
					<h2 className={styles.foundTitle}>계정/비밀번호 찾기</h2>
					<div className={styles.infoField}>
						<div className={styles.field}>
							<label className={styles.label}>계정</label>
							<span className={styles.value}>{email}</span>
						</div>
						<div className={styles.field}>
							<label className={styles.label}>비밀번호</label>
							<button
								type="button"
								className={styles.resetBtn}
								onClick={setPasswordModalOpen}>
								비밀번호 재설정
							</button>
						</div>
					</div>
					<button type="button" className={styles.loginButton} onClick={handleSignin}>
						로그인하러 가기
					</button>
				</form>
				{isPasswordModalOpen && (
					<PasswordChangeModal
						isOpen={isPasswordModalOpen}
						onClose={handleClosePasswordModal}
						onSubmit={onSubmit}
					/>
				)}
			</div>
		</FormProvider>
	)
}
